import ExploreLinks, { FooterLinksTree } from './ExploreLinks'

interface FooterMenuProps {
  footerLinks: FooterLinksTree
}

const FooterMenu = ({ footerLinks }: FooterMenuProps) => (
  <ExploreLinks tree={footerLinks} />
)

export default FooterMenu
